import { styled } from '@mui/material/styles';

export const Wrapper = styled('div')`
  width: auto;
  display: flex;
  padding: 0 1rem;
  height: auto;
`;
